import React from 'react';
import PropTypes from 'prop-types';
import Grid from 'material-ui/Grid';
import WarningIcon from 'material-ui-icons/Warning';
import Typography from 'material-ui/Typography';
import { withStyles } from 'material-ui/styles';

const styles = () => ({
  warning: {
    display: 'inline-flex'
  }
});

const WarningComponent = ({ classes, children }) => ( 
  <Grid item xs={12}>
    <Grid container justify="flex-end">
      <Typography color="error" variant="subheading">
        <div className={classes.warning}>
          <span><WarningIcon /></span>
          <span>{children}</span>
        </div>
      </Typography>
    </Grid>
  </Grid>
);

WarningComponent.propTypes = {
  classes: PropTypes.shape({
    warning: PropTypes.string
  }).isRequired,
  children: PropTypes.string.isRequired
}

export const Warning =  withStyles(styles)(WarningComponent);

export const LayerWarnings= ({ texts }) => {
  return texts ? (
    <div>
      {texts.map((text, index) => (
        // eslint-disable-next-line react/no-array-index-key
        text ? (<Warning key={index}>{text}</Warning>) : null
      ))}
    </div>

  ) : null;
};  

LayerWarnings.propTypes = {
  texts: PropTypes.arrayOf(PropTypes.string).isRequired
}

export default LayerWarnings;



// WEBPACK FOOTER //
// ./src/components/StackupDesign/EditLayer/LayerWarnings.js